import { useSeo } from "@/lib/seo";
import { trackPage } from "@/lib/track";
import { useEffect } from "react";
import "@/styles/home.css";

const SITE = "https://99tests.com";

export const COMPETITORS = {
  utest: {
    name: "uTest",
    seoTitle: "uTest alternative — real-device testing India",
    seoDesc: "99tests vs uTest: fixed-price real-device testing in India from ₹9,999, verified report in 3 days. See which fits your release.",
    short: "uTest",
    model: "a sales-led managed enterprise crowdtesting program",
    sub: "uTest (Applause) is the largest crowdtesting community in the world, built around managed enterprise programs. 99tests runs your test cases on real Indian phones and browsers for a fixed price you pay online, with a verified report in 3 business days.",
    table: [
      ["How you buy", "Talk to sales, scoped program, contract", "Pay online from ₹9,999 / $129, no account or call"],
      ["Time to first report", "Days to weeks after onboarding", "3 business days from payment"],
      ["Who writes the tests", "Applause test architects, or yours", "Yours — including AI-generated cases in any format"],
      ["Device coverage", "Global crowd, thousands of device types", "Indian-market devices: Redmi, Realme, Galaxy, Vivo, iPhone; Chrome/Edge/Safari/Firefox on Windows, macOS, ChromeOS"],
      ["Verification", "Applause triage team", "Every finding verified, duplicates merged, severity graded against a published rubric, screen recording on serious bugs"],
      ["Pricing model", "Custom quote, typically annual", "Three fixed packages, nothing further billed, unfilled sessions credited"],
      ["Best for", "Enterprise programs across many markets", "Teams shipping to Indian users who need results this week"],
    ],
    theirs: "uTest is the community arm of Applause, and Applause is built for large programs: multi-market localisation, payments testing across dozens of countries, accessibility audits, long-running managed engagements with a dedicated delivery team. If you are a global brand that needs a partner to design and run a testing program, that is the model.",
    ours: "99tests is built for the moment after your AI wrote 60 test cases and nobody has a Redmi 12 on a Jio connection to run them on. You upload the cases and the build, pick device targets, pay, and testers who personally own those devices run them in timed sessions. The report arrives in 3 business days with a coverage table, reproducible findings, and a verification record. There is no program to scope and no sales call.",
    detail: [
      ["Engagement", "uTest is managed and ongoing; 99tests is a job you buy per build."],
      ["Geography", "uTest's crowd is global; 99tests' 20,000 testers are in India, which matters if your users are on ₹9,000 Androids and Jio/Airtel networks."],
      ["Test input", "uTest typically runs test cycles designed with Applause; 99tests executes what you send — CSV, Excel, Sheets, Jira or TestRail exports, or cases from Cursor/Copilot/ChatGPT."],
      ["Scope", "uTest covers functional, usability, localisation, payments, accessibility, security; 99tests covers manual functional and exploratory execution only, and says so up front."],
      ["Report", "uTest reports live in the Applause platform; 99tests delivers a page and PDF you can attach to a Jira ticket."],
    ],
    pickThem: [
      "You need testing in 15 countries and 20 languages.",
      "You want a partner to design your QA strategy, not just run it.",
      "Procurement prefers an annual contract with a named delivery team.",
      "You need payments, accessibility or security testing in the same engagement.",
    ],
    pickUs: [
      "Your users are in India and your release is this week.",
      "You already have test cases (human- or AI-written) and need them executed on real devices.",
      "You want a fixed price and an invoice with GST, not a quote.",
      "You want to try crowdtesting on one build before committing to a program.",
    ],
    bothH: "Switching or running both",
    both: "Many teams run a managed program for the global release and buy 99tests jobs for India-specific regression before each sprint ends. Your existing test cases export straight from TestRail or Jira; no rewriting.",
    faq: [
      ["Is 99tests cheaper than uTest?", "They are priced differently. uTest quotes per program; 99tests charges a fixed ₹9,999 / $129 per Starter job. For a single build on Indian devices, 99tests is usually the smaller number. For a year-long multi-country program, compare the total."],
      ["Can 99tests replace uTest entirely?", "If your scope is manual functional and exploratory testing on Indian devices, yes. If you need localisation, payments or accessibility testing across markets, no — 99tests does not offer those."],
      ["Do 99tests testers have the same vetting?", "Every finding is verified before it reaches you: incomplete reports rejected, duplicates merged, severity graded against a published rubric. Sessions are timeboxed and paid whether or not bugs are found, so testers have no incentive to pad."],
    ],
  },
  testlio: {
    name: "Testlio",
    seoTitle: "Testlio alternative — real-device testing",
    seoDesc: "99tests vs Testlio: fixed-price real-device testing in India from ₹9,999, with a verified report in 3 days. See which suits your team.",
    short: "Testlio",
    model: "an ongoing managed QA partnership",
    sub: "Testlio pairs a vetted freelance network with a managed platform for ongoing QA partnerships. 99tests runs your test cases on real Indian phones and browsers for a fixed price you pay online, with a verified report in 3 business days.",
    table: [
      ["How you buy", "Sales-led, platform subscription plus testing services", "Pay online from ₹9,999 / $129, no account or call"],
      ["Engagement", "Ongoing managed partnership with a Testlio team", "Per-build job; buy again when you need it"],
      ["Tester network", "Vetted freelance network, global", "20,000 testers in India on their own devices"],
      ["Who writes the tests", "Testlio test leads, or yours", "Yours — including AI-generated cases in any format"],
      ["Device coverage", "Global", "Indian-market Android and iPhone; desktop browsers on Windows, macOS, ChromeOS"],
      ["Verification", "Testlio team triage", "Every finding verified, duplicates merged, severity graded, screen recording on serious bugs"],
      ["Pricing model", "Custom, typically annual", "Three fixed packages, nothing further billed"],
      ["Best for", "Product teams that want an outsourced QA function", "Teams that need a specific build tested on Indian devices now"],
    ],
    theirs: "Testlio is built to be your QA function: a platform, a network of vetted testers, and a Testlio team that plans cycles, manages testers and reports back. Streaming, media, fintech and marketplace companies use it as a long-term outsourced QA partner with SLAs and integrations into Jira and TestRail.",
    ours: "99tests is built for a narrower job done fast: you have a build and a set of test cases, and you need a person on a Redmi or an iPhone 11 on an Indian network to run them and tell you what broke. Pay, upload, get a verified report in 3 business days. No platform to adopt, no partnership to manage.",
    detail: [
      ["Commitment", "Testlio expects an ongoing relationship; 99tests is transactional by design."],
      ["Onboarding", "Testlio onboards your team onto its platform and processes; 99tests needs a build link and a spreadsheet."],
      ["Test design", "Testlio can design test strategy and cases; 99tests executes what you provide."],
      ["Geography", "Testlio's network is global; 99tests is India-only and specific about which devices and networks that means."],
      ["Integrations", "Testlio integrates deeply with Jira/TestRail; 99tests accepts their exports as input and gives you a PDF and page back."],
      ["Scope", "Testlio covers functional, localisation, payments, live-event and more; 99tests covers manual functional and exploratory only."],
    ],
    pickThem: [
      "You want to outsource QA as a function, not buy it as a job.",
      "You need coverage across many countries and testing types.",
      "You want tester management, cycle planning and reporting handled for you.",
      "You value deep tooling integration over speed of first result.",
    ],
    pickUs: [
      "You need one build tested on Indian devices this week.",
      "Your test cases already exist, possibly AI-generated, and you want them executed, not redesigned.",
      "Fixed price and GST invoice beat a quote and contract.",
      "You are validating whether real-device crowd testing finds bugs your automation misses, before committing to a partner.",
    ],
    bothH: "Switching or running both",
    both: "Teams on Testlio often keep it for the global program and add 99tests jobs for India-specific regression on budget Android — the segment where emulator and device-farm coverage is thinnest.",
    faq: [
      ["Does 99tests offer a managed service like Testlio?", "No. 99tests is self-serve: you scope the job by choosing a package and device targets. Verification of findings is done by 99tests before delivery, but there is no dedicated account team."],
      ["Which is faster?", "99tests delivers Starter and Standard reports in 3 business days from payment. Testlio timelines depend on the engagement and are set with your Testlio team."],
      ["Can I send Testlio-format test cases to 99tests?", "Yes. 99tests accepts TestRail and Jira exports, CSV, Excel, Sheets, Word, Markdown and plain text."],
    ],
  },
  "browserstack-app-live": {
    name: "BrowserStack App Live",
    seoTitle: "BrowserStack App Live alternative",
    seoDesc: "99tests vs BrowserStack App Live: real people on real Indian devices from ₹9,999, verified report in 3 days — not a remote device cloud.",
    short: "BrowserStack App Live",
    model: "a device cloud your own engineers drive remotely",
    sub: "BrowserStack App Live gives your own engineers remote access to real devices in a cloud farm. 99tests gives you other people — 20,000 testers who own the devices your Indian users own — to run your test cases and report back in 3 business days.",
    table: [
      ["What it is", "Device cloud: you drive a real device remotely", "Human testing service: testers run your cases on their own devices"],
      ["Who does the testing", "Your engineers and QA", "99tests' verified crowd"],
      ["How you buy", "Monthly or annual subscription per user", "Pay per job, from ₹9,999 / $129"],
      ["Device access", "Thousands of device/OS combos, data-centre hosted, instantly", "Devices as they exist in users' pockets — carrier SIMs, real networks, real battery and storage state"],
      ["Network conditions", "Simulated throttling", "Actual Jio, Airtel, Vi connections in the tester's location"],
      ["Best for", "Debugging a specific device issue yourself, right now", "Finding out what real users on real Indian devices will hit before you ship"],
    ],
    theirs: "App Live is a tool for engineers. You pick a device from a catalogue, it appears in your browser in seconds, and you tap through your app yourself. It is unbeatable for reproducing a bug on a specific OS version, checking layout on a device you do not own, or running automation at scale with the sibling Automate product. BrowserStack is also a Bengaluru-founded company with a large Indian device catalogue.",
    ours: "99tests is a service, not a tool. It answers a different question: not \"can I access a Galaxy A15?\" but \"what happens when 5 different people on their own Galaxy A15s, Redmi 12s and iPhone 11s run my 40 test cases on Jio and Airtel networks?\" Testers use devices with a year of real photos, apps and battery wear, on real carriers, in real locations. Findings are verified and severity-graded before you see them.",
    detail: [
      ["Labour", "App Live costs your team's hours; 99tests costs a fixed fee and none of your team's hours."],
      ["Device state", "farm devices are clean and reset; tester devices have MIUI battery optimisation switched on, low storage, and 30 background apps — which is where bugs live."],
      ["Network", "farm devices sit on data-centre connections with optional throttling; tester devices are on the carrier and cell tower your users are on."],
      ["Coverage per rupee", "App Live gives one engineer one device at a time; a 99tests Standard job gives 10 sessions across 4 devices with different humans."],
      ["Bug discovery", "App Live finds what you think to look for; exploratory sessions on 99tests find what you did not."],
      ["Automation", "BrowserStack Automate runs scripts at scale; 99tests does not do automation and says so."],
    ],
    pickThem: [
      "You need to reproduce and debug a specific issue on a specific device yourself.",
      "You run automated suites and want them on real devices.",
      "Your engineers want instant access to devices during development.",
      "You need a very wide device matrix beyond the Indian market.",
    ],
    pickUs: [
      "You want humans to run your test cases, not just a device to run them on.",
      "You care about behaviour on real carriers and real device state, not a clean lab unit.",
      "Your engineers' time is worth more than ₹9,999.",
      "You want exploratory findings, not only pass/fail on scripted steps.",
    ],
    bothH: "Running both",
    both: "This is the common pattern: BrowserStack during development and for automation, then a 99tests job on the release candidate for human real-world coverage on Indian devices. They are complements, not substitutes.",
    faq: [
      ["Is 99tests a device farm?", "No. Testers use their own devices in their own locations. There is no remote access; you get a report, not a device session."],
      ["Can I use 99tests for automation?", "No. 99tests is manual and exploratory execution by people. For automated runs on real devices, use BrowserStack Automate or similar."],
      ["Which finds more bugs?", "Different bugs. App Live finds what your engineer looks for on a clean device. 99tests finds what a person with a full phone on a weak Jio signal hits when following your test cases and then poking around."],
    ],
  },
  "test-io": {
    name: "test IO",
    seoTitle: "test IO alternative — real-device testing",
    seoDesc: "99tests vs test IO: fixed-price real-device testing in India from ₹9,999, verified report in 3 days. See which fits your release.",
    short: "test IO",
    model: "a subscription crowdtesting platform for continuous QA",
    sub: "test IO (an EPAM company) sells continuous crowdtesting on a monthly plan, with a global tester community running exploratory and test-case cycles inside its platform. 99tests runs your test cases on real Indian phones and browsers for a fixed price you pay online, with a verified report in 3 business days.",
    table: [
      ["How you buy", "Monthly subscription, sales-assisted onboarding", "Pay online per job from ₹9,999 / $129, no account or call"],
      ["Engagement", "Continuous testing cycles across sprints", "One build, one job; buy again when you need it"],
      ["Tester network", "Global community, matched per cycle", "20,000 testers in India on their own devices"],
      ["Who writes the tests", "test IO customer success, or yours", "Yours — including AI-generated cases in any format"],
      ["Device coverage", "Global device pool", "Indian-market Android and iPhone; desktop browsers on Windows, macOS, ChromeOS"],
      ["Verification", "test IO team reviews and approves bugs", "Every finding verified, duplicates merged, severity graded, screen recording on serious bugs"],
      ["Pricing model", "Tiered monthly plans", "Three fixed packages, nothing further billed"],
      ["Best for", "Teams that want crowdtesting on every sprint", "Teams that need a specific build tested on Indian devices now"],
    ],
    theirs: "test IO is built for continuous QA: you plug crowdtesting into every sprint, launch cycles from its platform or integrations, and a global community runs exploratory and scripted tests while a test IO team filters what comes back. If you release weekly across many markets and want a standing crowd on tap, that is the model.",
    ours: "99tests is built for the release that needs real Indian devices this week. You upload the cases and the build, pick device targets, pay, and testers who personally own those devices run them in timed sessions. The report arrives in 3 business days with a coverage table, reproducible findings and a verification record. No subscription, no platform to adopt.",
    detail: [
      ["Commitment", "test IO is a monthly plan you keep running; 99tests is a job you buy per build."],
      ["Geography", "test IO's community is global; 99tests is India-only and specific about which devices and networks that means."],
      ["Test input", "test IO cycles are configured in its platform; 99tests executes what you send — CSV, Excel, Sheets, Jira or TestRail exports, or AI-generated cases."],
      ["Scope", "test IO covers exploratory, test-case, usability and regression testing; 99tests covers manual functional and exploratory execution only."],
      ["Report", "test IO bugs land in its dashboard and your tracker; 99tests delivers a page and PDF you can attach to a Jira ticket."],
    ],
    pickThem: [
      "You ship every sprint and want crowdtesting running continuously.",
      "Your users are spread across many countries and languages.",
      "You want cycles launched from your CI or tracker integrations.",
      "A monthly plan fits your budgeting better than per-build purchases.",
    ],
    pickUs: [
      "You have one build that must be tested on Indian devices this week.",
      "Your test cases already exist, possibly AI-generated, and just need running.",
      "You want a fixed price and a GST invoice, not a plan tier.",
      "You want to see what real-device crowd testing finds before subscribing to anything.",
    ],
    bothH: "Switching or running both",
    both: "Teams on test IO sometimes keep the subscription for global exploratory coverage and buy 99tests jobs when a release needs budget Android and Indian carrier coverage that a global pool spreads thin.",
    faq: [
      ["Is 99tests a subscription like test IO?", "No. Each 99tests job is a one-off purchase — Starter, Standard or Deep — with nothing billed afterwards. Buy the next one when you have the next build."],
      ["Which is faster to a first report?", "99tests delivers Starter and Standard reports in 3 business days from payment, with no onboarding step. test IO turnaround depends on your plan and cycle setup."],
      ["Can I move my test IO test cases to 99tests?", "Yes. Export them to CSV or Excel, or paste them as plain text. 99tests parses them into sessions and shows you the coverage before testers start."],
    ],
  },
  "global-app-testing": {
    name: "Global App Testing",
    seoTitle: "Global App Testing alternative in India",
    seoDesc: "99tests vs Global App Testing: fixed-price real-device testing from ₹9,999, verified 3-day report. See which fits your release.",
    short: "Global App Testing",
    model: "a managed crowdtesting service with fast-turnaround exploratory and test-case runs",
    sub: "Global App Testing runs managed exploratory and test-case execution through a vetted global crowd, sold as a service to product and QA teams. 99tests runs your test cases on real Indian phones and browsers for a fixed price you pay online, with a verified report in 3 business days.",
    table: [
      ["How you buy", "Sales-led, quoted per engagement or plan", "Pay online per job from ₹9,999 / $129, no account or call"],
      ["Engagement", "Managed service with a GAT team", "Self-serve job; verification by 99tests before delivery"],
      ["Tester network", "Vetted crowd in 190+ countries", "20,000 testers in India on their own devices"],
      ["Who writes the tests", "GAT can write and run, or use yours", "Yours — including AI-generated cases in any format"],
      ["Device coverage", "Global", "Indian-market Android and iPhone; desktop browsers on Windows, macOS, ChromeOS"],
      ["Verification", "GAT team triage", "Every finding verified, duplicates merged, severity graded, screen recording on serious bugs"],
      ["Pricing model", "Custom quote", "Three fixed packages, nothing further billed"],
      ["Best for", "Localisation and launch testing across many markets", "Teams shipping to Indian users who need results this week"],
    ],
    theirs: "Global App Testing is built for teams launching in many markets at once: localisation checks, exploratory sweeps and test-case runs by testers in the exact countries you are shipping to, coordinated by a GAT team and delivered through its platform and integrations. If you need people in Brazil, Germany and Japan on the same release, that is the model.",
    ours: "99tests is built for depth in one market. Your users are on ₹9,000 Androids with MIUI killing background apps, on Jio and Airtel networks — and the testers who own those exact phones run your cases in timed sessions. Pay online, upload, get a verified report in 3 business days. No quote, no account team.",
    detail: [
      ["Buying", "GAT is quoted and managed; 99tests is priced on the page and bought with a card."],
      ["Geography", "GAT's strength is breadth across countries; 99tests' strength is depth across Indian devices, skins and carriers."],
      ["Test input", "GAT can design cases for you; 99tests executes the cases you bring, in any format."],
      ["Scope", "GAT covers exploratory, test-case, localisation and launch testing; 99tests covers manual functional and exploratory only."],
      ["Report", "GAT results live in its platform and integrations; 99tests delivers a page and PDF with a coverage table and recordings."],
    ],
    pickThem: [
      "You are launching in several countries and need testers in each.",
      "You want localisation and cultural checks alongside functional testing.",
      "You want a managed team to scope and run cycles for you.",
      "Procurement prefers a quoted engagement with a named contact.",
    ],
    pickUs: [
      "Your release is for India and it ships this week.",
      "You already have test cases and need them executed on real budget Androids and iPhones.",
      "You want a fixed price and a GST invoice, not a quote.",
      "You want to try crowdtesting on one build before committing to a service.",
    ],
    bothH: "Switching or running both",
    both: "A common pattern is GAT for the multi-country launch and a 99tests job for the India-specific regression pass on budget Android before each release — the segment where a global crowd is thinnest.",
    faq: [
      ["Does 99tests test outside India?", "No. 99tests testers are in India, on Indian devices and carriers, and the service says so up front. For other markets, a global provider like Global App Testing is the right tool."],
      ["Is 99tests managed like Global App Testing?", "No. 99tests is self-serve: you choose a package and device targets and upload your cases. Findings are verified by 99tests before delivery, but there is no dedicated account team."],
      ["How do prices compare?", "They are priced differently. Global App Testing quotes per engagement; 99tests charges a fixed ₹9,999 / $129 for a Starter job. For a single Indian-device build, 99tests is usually the smaller number; for a multi-country launch, compare the total."],
    ],
  },
};

function Header() {
  return (
    <header className="site-header"><div className="wrap">
      <a className="logo" href="/"><i></i>99tests</a>
      <nav>
        <a href="/#how">How it works</a>
        <a href="/devices" data-testid="nav-devices">Devices</a>
        <a href="/pricing">Pricing</a>
        <a href="/about" data-testid="nav-about">About</a>
        <a href="https://blog.99tests.com/" data-testid="nav-blog">Blog</a>
        <a href="#faq">Questions</a>
        <a className="btn sm blue" href="/pricing" data-testid="compare-start-job-btn">Start a job</a>
      </nav>
    </div></header>
  );
}

function Footer({ slug }) {
  return (
    <footer className="site-footer"><div className="wrap">
      <div>© 2026 99tests · Bengaluru<br /><span className="small">Not test automation. Not a certification or an audit under any standard.</span></div>
      <div data-testid="compare-also">
        <span className="small" style={{ marginRight: 6 }}>Also compare:</span>
        {Object.entries(COMPETITORS).filter(([s]) => s !== slug).map(([s, c]) => <a key={s} href={`/vs/${s}`}>{c.short}</a>)}
        <a href="/vs-device-clouds-and-automation">Device clouds &amp; automation</a>
      </div>
      <div>
        <a href="/crowdsourced-testing">Crowdsourced testing</a>
        <a href="/">Home</a>
        <a href="/join">Become a tester</a>
        <a href="/mcp-server" data-testid="footer-mcp">For AI agents (MCP)</a>
        <a href="/terms">Client terms</a>
        <a href="/privacy">Privacy</a>
        <a href="mailto:hello@99tests.com">hello@99tests.com</a>
      </div>
    </div></footer>
  );
}

function Picks({ title, items, testid }) {
  return (
    <div data-testid={testid}>
      <h4>{title}</h4>
      <ul style={{ paddingLeft: 18, margin: "8px 0 0", color: "var(--muted)" }}>
        {items.map((t, i) => <li key={i} style={{ margin: "6px 0" }}>{t}</li>)}
      </ul>
    </div>
  );
}

export default function Compare({ slug }) {
  const c = COMPETITORS[slug];
  const path = `/vs/${slug}`;
  const title = c.seoTitle || `${c.name} alternative for real-device testing in India`;
  const jsonld = {
    "@context": "https://schema.org",
    "@graph": [
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: "Crowdsourced testing", item: SITE + "/crowdsourced-testing" },
        { "@type": "ListItem", position: 3, name: `99tests vs ${c.name}`, item: SITE + path },
      ] },
      { "@type": "FAQPage", mainEntity: c.faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) },
    ],
  };
  useSeo({
    title,
    description: c.seoDesc || `Comparing 99tests and ${c.name}: fixed-price real-device testing from ₹9,999 with a verified report in 3 days vs ${c.model}. See which fits your release.`,
    path,
    jsonld,
  });
  useEffect(() => { trackPage(path); }, [path]);

  return (
    <>
      <Header />
      <main data-testid={`compare-${slug}`}>
        <section className="hero">
          <div className="wrap">
            <div>
              <div className="ref"><b>Fixed price</b><span className="dot"></span><b>3 business days</b><span className="dot"></span><span>Different tools for different jobs</span></div>
              <h1>99tests vs {c.name}:<br /><em>which one fits your next release?</em></h1>
              <p className="lede">{c.sub}</p>
              <div className="actions">
                <a className="btn blue" href="/pricing" data-testid="compare-packages-btn">See packages</a>
                <a className="btn ghost" href="/sample-report/" data-testid="compare-sample-report-link">Read a sample report</a>
              </div>
            </div>
          </div>
        </section>

        <section className="band">
          <div className="wrap">
            <div className="section-head"><span className="eyebrow">The 30-second answer</span><h2>Side by side.</h2></div>
            <div style={{ overflow: "auto" }}>
              <table className="tbl" data-testid="compare-table">
                <thead><tr><th>{"\u00a0"}</th><th>{c.name}</th><th style={{ color: "var(--ink)" }}>99tests</th></tr></thead>
                <tbody>{c.table.map(([k, a, b], i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 600 }}>{k}</td>
                    <td className="small" style={{ color: "var(--muted)" }}>{a}</td>
                    <td className="small" style={{ fontWeight: 600, color: "var(--ink)" }}>{b}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </div>
        </section>

        <section>
          <div className="wrap">
            <div className="proof" data-testid="compare-built-for">
              <div><h4>What {c.name} is built for</h4><p>{c.theirs}</p></div>
              <div><h4>What 99tests is built for</h4><p>99tests is a <a href="/crowdsourced-testing">crowdsourced testing service</a> built for Indian releases. {c.ours}</p></div>
            </div>
          </div>
        </section>

        <section className="band">
          <div className="wrap">
            <div className="section-head"><span className="eyebrow">Side-by-side detail</span><h2>Where they differ.</h2></div>
            <div className="narrow" style={{ marginLeft: 0 }}>
              {c.detail.map(([k, v], i) => <p key={i}><b>{k}:</b> {v}</p>)}
            </div>
          </div>
        </section>

        <section>
          <div className="wrap">
            <div className="proof">
              <Picks title={`When to pick ${c.name}`} items={c.pickThem} testid="compare-pick-them" />
              <Picks title="When to pick 99tests" items={c.pickUs} testid="compare-pick-us" />
              <div><h4>{c.bothH}</h4><p>{c.both}</p></div>
            </div>
          </div>
        </section>

        <section className="band" id="faq">
          <div className="wrap narrow" style={{ marginLeft: 0 }}>
            <div className="section-head"><span className="eyebrow">Questions</span><h2>Before you choose.</h2></div>
            <div className="faqbox" data-testid="compare-faq">
              {c.faq.map(([q, a], i) => (
                <details className="f" key={i} open={i === 0}><summary>{q}</summary><p>{a}</p></details>
              ))}
            </div>
          </div>
        </section>

        <section style={{ borderTop: 0 }}>
          <div className="wrap">
            <div className="cta">
              <div>
                <h2>Try it on one build.</h2>
                <p>Pay, upload your test cases, and testers are on it within the hour. Verified report in three business days.</p>
              </div>
              <a className="btn" href="/pricing">See packages</a>
            </div>
          </div>
        </section>
      </main>
      <Footer slug={slug} />
    </>
  );
}
